<template>
    <div class="text-wrapper" :style="{ width: isRichInputBig ? '100%' : '500px', height: isRichInputBig ? '500px' : '226px' }">
        <TextEditor :value="data" :language="currLanguage" :hiddenBtns="hiddenBtns" :placeholder="placeholder" @change="inputChange" @magnify="magnify" />
        <!-- 首次使用指引设置 -->
        <div class="guide-review">
            <FirstGuide :hasShow="isShowGuide" />
        </div>
    </div>
</template>

<script>
import TextEditor from "@/views/zhiji/components/textEditor/Editor";
import FirstGuide from "./textItem/FirstGuide";

export default {
    name: "PlatTextLink",
    props: ["data"],
    components: {
        FirstGuide,
        TextEditor
    },
    data() {
        return {
            hiddenBtns: {},
            isRichInputBig: false,
        };
    },
    computed: {
        placeholder() {
            return this.$t("zhiji.answer.textWidget.enterTextTip");
        },
        isShowGuide() {
            let platTextArr = [];
            let currentAnswer = this.$store.state.zhiji.questionEdit["currentAnswer"];
            currentAnswer.contents &&
                currentAnswer.contents.forEach(item => {
                    if (item.wtType == "PlatTextLink") {
                        platTextArr.push(item);
                    }
                });
            return platTextArr.length == 1 && platTextArr[0].updateState == "add" ? true : false;
        },
        currLanguage() {
            return this.$store.state.zhiji.questionEdit["currentSynonym"];
        }
    },
    methods: {
        inputChange(data) {
            this.commitStore({
                text: data.text,
                linkWord: data.linkWord,
                cmd: data.cmd,
                cmdTagClassify: data.cmdTagClassify,
                isOld: data.isOld,
            });
        },
        commitStore(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: widget
            });
        },
        magnify() {
            this.isRichInputBig = !this.isRichInputBig;
        }
    },
    mounted() {
        document.addEventListener("click", this.handleDocumentClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.handleDocumentClick);
    }
};
</script>

<style lang="less" scoped>
.text-wrapper {
    position: relative;
    width: 500px;
    height: 226px;
    border: 1px solid #d8e4f0;
    border-radius: 4px;

    .guide-review {
        // 1期不做颜色配置，暂时写死 TODO
        display: none;
    }
}
</style>
